export enum OnboardingInstitutionsContext {
  INVITATION = 'INVITATION',
  SIGNUP_CODE = 'SIGNUP_CODE',
  INSTITUTION_ID = 'INSTITUTION_ID',
}
